import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AuthService} from "../../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {takeUntil} from "rxjs/operators";
import {
  DictService,
  RECEIVABLES_IMPORT_ROW_STATUS,
  RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED,
  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION,
  RECEIVABLES_IMPORT_ROW_STATUS_NEW,
  RECEIVABLES_IMPORT_ROW_STATUS_PAID, RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_ASF,
  RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU,
  RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED,
  RECEIVABLES_IMPORT_ROW_STATUS_REJECTED,
  RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED,
  RECEIVABLES_IMPORT_ROW_STATUS_UNPAID,
  SERVICE_TYPE
} from "../../../../shared/services/dict.service";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {ChangeRegistrationDialogComponent} from "../change-registration-dialog/change-registration-dialog.component";
import {
  ConfirmDialogWithReasonComponent
} from "../../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";
import {PolicyOverrideDialogComponent} from "../policy-override-dialog/policy-override-dialog.component";
import {
  ChangeStatusReceivablesImportsRowDialogComponent
} from "../change-status-receivables-imports-row-dialog/change-status-receivables-imports-row-dialog.component";

@Component({
  selector: 'app-receivables-imports-row-details-view',
  templateUrl: './receivables-imports-row-details-view.component.html',
  styleUrls: ['./receivables-imports-row-details-view.component.scss']
})
export class ReceivablesImportsRowDetailsViewComponent implements OnInit, OnDestroy {
  @Input() receivablesImportsRow: Observable<ReceivablesImportRow>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();


  userPermissions: ReplaySubject<UserPermissions>;
  receivablesImportsRowObject?: ReceivablesImportRow;

  readonly RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION = RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_NEW = RECEIVABLES_IMPORT_ROW_STATUS_NEW;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_UNPAID = RECEIVABLES_IMPORT_ROW_STATUS_UNPAID;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_PAID = RECEIVABLES_IMPORT_ROW_STATUS_PAID;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED = RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_REJECTED = RECEIVABLES_IMPORT_ROW_STATUS_REJECTED;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED = RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED;
  readonly RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED = RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private receivablesImportsRowService: ReceivablesImportsRowService,
    private snack: MatSnackBar,
    private router: Router,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.receivablesImportsRow
      .pipe(takeUntil(this.destroyed$))
      .subscribe((receivablesImportRow: ReceivablesImportRow) => {
        this.receivablesImportsRowObject = receivablesImportRow;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  rejectedRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogWithReasonComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Odrzucona?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.accepted) {
        this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_REJECTED, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesImportsRowService.cancelRow(
              this.receivablesImportsRowObject.uuid,
              result.reason,
              dictId,
              '',
              ''
            )
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });

          });
      }
    });
  }

  cancelRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogWithReasonComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Anulowana?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.accepted) {
        this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesImportsRowService.cancelRow(
              this.receivablesImportsRowObject.uuid,
              result.reason,
              dictId,
              '',
              ''
            )
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });

          });
      }
    });
  }
  unpaidRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Nieopłacona?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_UNPAID, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesImportsRowService.cancelRow(
              this.receivablesImportsRowObject.uuid,
              '',
              dictId,
              '',
              ''
            )
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });

          });
      }
    });
  }
  paidToTuRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Opłacona do TU?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_TU, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesImportsRowService.cancelRow(
              this.receivablesImportsRowObject.uuid,
              '',
              dictId,
              '',
              ''
            )
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });

          });
      }
    });
  }
  paidToASFRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Opłacona do ASF?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_PAID_TO_ASF, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesImportsRowService.cancelRow(
              this.receivablesImportsRowObject.uuid,
              '',
              dictId,
              '',
              ''
            )
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });

          });
      }
    });
  }

  toCancelRow(): void {
    const dialogRef = this.dialog.open(ChangeStatusReceivablesImportsRowDialogComponent, {
      width: '500px',
      data: {receivablesObject: this.receivablesImportsRowObject},
    });

    dialogRef.afterClosed().subscribe(result => {
      this.changed.emit();
    });
  }

  newRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Nowa?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_NEW, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesImportsRowService.newRow(this.receivablesImportsRowObject.uuid, dictId)
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });
          });
      }
    });
  }

  registrationChange(): void {
    const dialogRef = this.dialog.open(ChangeRegistrationDialogComponent, {
      width: '700px',
      data: {
        receivablesObject: this.receivablesImportsRowObject,
        insuranceCompany: this.receivablesImportsRowObject.insuranceCompany
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.changed.emit();
    });
  }

  policyOverride(): void {
    const dialogRef = this.dialog.open(PolicyOverrideDialogComponent, {
      width: '700px',
      data: {
        receivablesObject: this.receivablesImportsRowObject,
        insuranceCompany: this.receivablesImportsRowObject.insuranceCompany
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.changed.emit();
    });
  }

  restoreRow(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na Do weryfikacji?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.getId(RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION, RECEIVABLES_IMPORT_ROW_STATUS)
          .subscribe((dictId: number) => {
            this.receivablesImportsRowService.verificationRow(this.receivablesImportsRowObject.uuid, dictId)
              .subscribe(() => {
                this.changed.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              });
          });
      }
    });
  }

  downloadDocument(): void {
    this.receivablesImportsRowService.downloadDocument(
      this.receivablesImportsRowObject.uuid,
    );
  }

}
